/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

export const SET_LANG = "SET_LANG";
export const SET_AUTH = "SET_AUTH";

export const SET_USER = "SET_USER";
export const SET_USER_EMAIL = "SET_USER_EMAIL";
export const SET_USER_PHONENUMBER = "SET_USER_PHONENUMBER"

export const SET_QUERY_PARAMETERS = "SET_QUERY_PARAMETERS"
